import { supabase } from "./supabaseClient";

export async function getMyProfile() {
  const { data: u, error: uErr } = await supabase.auth.getUser();
  if (uErr) return { data: null, error: uErr };
  const me = u?.user?.id;
  if (!me) return { data: null, error: new Error("Not authenticated") };

  const { data, error } = await supabase
    .from("profiles")
    .select("id,email,my_label,partner_label")
    .eq("id", me)
    .single();

  return { data, error };
}

export async function updateMyLabels({ my_label, partner_label }) {
  const { data: u, error: uErr } = await supabase.auth.getUser();
  if (uErr) return { data: null, error: uErr };
  const me = u?.user?.id;
  if (!me) return { data: null, error: new Error("Not authenticated") };

  const patch = {
    my_label: String(my_label || "").trim().slice(0, 30),
    partner_label: String(partner_label || "").trim().slice(0, 30),
  };

  if (!patch.my_label) return { data: null, error: new Error("Your label cannot be empty.") };
  if (!patch.partner_label) return { data: null, error: new Error("Partner label cannot be empty.") };

  const { data, error } = await supabase
    .from("profiles")
    .update(patch)
    .eq("id", me)
    .select("id,email,my_label,partner_label")
    .single();

  return { data, error };
}
